<template>
  <router-link
    :to="{ name: PATH_INVOICE }"
    @click.native="handleClick"
    v-if="!isButtonHidden"
  >
    <Button
      class="el-button--only-icon-for-xxs"
      icon="icon icon-invoice-new"
      new-design
      size="large"
      type="warning"
    >
      {{ $t('button.createInvoice') }}
    </Button>
  </router-link>
</template>

<script>
import { PATH_INVOICE, PATH_INVOICE_TEMPLATE_SHOW } from '~/router';

export default {
  data: () => ({
    PATH_INVOICE,
    PATH_INVOICE_TEMPLATE_SHOW,
  }),
  computed: {
    isButtonHidden() {
      return this.$route.name === PATH_INVOICE_TEMPLATE_SHOW || this.$route.name === PATH_INVOICE;
    },
  },
  methods: {
    handleClick() {
      this.$emit('handle-click');
    },
  },
};
</script>
